import React, { Component } from 'react';
import classnames from 'classnames';
import styles from './styles.module.css';

import Square from '../../../components/square';
import ItemImage from '../../../components/item-image';
import ImagePlaceholder from '../../../components/image-placeholder';
import GalleryIcon from '../../../icons/Gallery';
import CameraIcon from '../../../icons/Camera';
import CrossIcon from '../../../icons/Cross';

export default class Gallery extends Component {
  state = {
    active: 0,
    overlayOpen: false
  };

  toggleGallery = () => {
    ga('send', {
      hitType: 'event',
      eventCategory: 'Gallery',
      eventAction: this.state.overlayOpen ? 'CloseGallery' : 'OpenGallery',
      eventLabel: this.props.itemId
    });
    this.setState({ overlayOpen: !this.state.overlayOpen });
  };

  setSelectedImage = active => this.setState({ active });

  render() {
    const { itemId, addImage, editImages, images, title } = this.props;

    return (
      <div className={styles.container}>
        <div className={styles.mainImage}>
          {images.length > 0 ? (
            <Square>
              <button
                className={styles.focusedImageButton}
                onClick={this.toggleGallery}
              >
                <div className={styles.imageContainer}>
                  <ItemImage
                    itemId={itemId}
                    imageId={images[this.state.active]}
                    sizeOverride="80-blur"
                  />
                  <ItemImage
                    itemId={itemId}
                    imageId={images[this.state.active]}
                    sizes="(min-width: 1200px) 440px, (min-width: 768px) calc(50vw - 10rem), calc(100vw - 4rem)"
                    alt={`Image of ${title}`}
                  />
                  <div className={styles.buttonText}>View larger image</div>
                </div>
              </button>
            </Square>
          ) : (
            <ImagePlaceholder />
          )}
        </div>
        <div className={styles.manageLinks}>
          <button onClick={addImage}>
            <CameraIcon size={24} color="#fff" />
            <span>Add Images</span>
          </button>
          {/* <button onClick={editImages}>
            <GalleryIcon size={24} color="#fff" />
            <span>Edit Images</span>
          </button> */}
        </div>
        <div className={classnames(styles.links, styles.pageLinks)}>
          <ul>
            {images.length > 0 && (
              <li>
                <button
                  className={styles.galleryButton}
                  onClick={this.toggleGallery}
                >
                  <GalleryIcon size={24} color="#fff" />
                  <span>Gallery</span>
                </button>
              </li>
            )}
            {images.map((image, index) => (
              <li key={image}>
                <button
                  className={styles.imageButton}
                  onClick={() => this.setSelectedImage(index)}
                >
                  <Square>
                    <div className={styles.imageContainer}>
                      <ItemImage
                        itemId={itemId}
                        imageId={image}
                        sizeOverride="80-blur"
                      />
                      <ItemImage itemId={itemId} imageId={image} sizes="80px" />
                    </div>
                  </Square>
                </button>
              </li>
            ))}
          </ul>
        </div>
        {images.length > 0 && (
          <div
            className={classnames(styles.overlay, {
              [styles.open]: this.state.overlayOpen
            })}
          >
            <div className={styles.nav}>
              <div className={styles.links}>
                <ul>
                  <li>
                    <button
                      className={styles.galleryButton}
                      onClick={this.toggleGallery}
                    >
                      <CrossIcon size={24} color="#fff" />
                      <span>Exit</span>
                    </button>
                  </li>
                  {images.map((image, index) => (
                    <li key={image}>
                      <button
                        className={styles.imageButton}
                        onClick={() => this.setSelectedImage(index)}
                      >
                        <Square>
                          <div className={styles.imageContainer}>
                            <ItemImage
                              itemId={itemId}
                              imageId={image}
                              sizeOverride="80-blur"
                            />
                            <ItemImage
                              itemId={itemId}
                              imageId={image}
                              sizes="80px"
                            />
                          </div>
                        </Square>
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className={styles.galleryImage}>
              <div>
                <ItemImage
                  itemId={itemId}
                  imageId={images[this.state.active]}
                  sizes="(min-width: 768px) calc(100vw - 9rem), calc(100vw - 2rem)"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/page-components/glass-detail/gallery/index.js